/**
 * Hook to extract text from ExploreEntry or Recipe
 * Created by neo on 21.01.26
 */
import { useLanguage } from '../../Hooks/useLanguage';
import { useLocalized } from '../../Hooks/useLocalized';
import { ExploreEntry } from '../../Model/Explore/ExploreEntry';
import { getMediaMedium, getMediaLarge } from '../../Model/Media/Media';
import { Recipe } from '../../Model/Diet/Recipe/Recipe';

export const useEntryText = (entry: ExploreEntry | Recipe) => {
  const { language } = useLanguage();
  const title = useLocalized(entry.name);
  const longDescription = useLocalized(entry.description).substring(0, 100);
  const isRecipe = entry.type === 'recipe';
  const exploreShortDescription = useLocalized(isRecipe ? [] : (entry as ExploreEntry).shortDescription);
  const shortDescription = isRecipe
    ? `${Math.floor((entry as Recipe).nutrition?.nutrients.calories?.amount || 0)} kcal`
    : exploreShortDescription;
  const description = shortDescription || (longDescription ? `${longDescription}...` : '');

  const duration = 'durationInMinutes' in entry ? (entry as any).durationInMinutes : undefined;
  const type = 'type' in entry ? (entry as any).type : 'recipe';
  const image = entry.getImage(language);

  return {
    title,
    description,
    duration,
    type,
    image,
    imageMedium: image ? getMediaMedium(image) : undefined,
    imageLarge: image ? getMediaLarge(image) : undefined,
  };
};
